<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Rental GIN
      </h6>

      <div style="padding-bottom: 120px;" class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0;" class="navbar background_color">
          <div class="d-flex flex-column flex-md-row flex-wrap gap-2">
            <b-input-group size="sm" class="w-100" style="max-width: 225px;">
              <b-form-input v-model="filter" @input="loadRentalGins()" type="search" placeholder="Search" />
            </b-input-group>

            <b-input-group size="sm" class="w-100" style="max-width: 170px;">
              <b-form-input v-model="fromDate" @input="loadRentalGins()" type="date" />
            </b-input-group>

            <b-input-group size="sm" class="w-100" style="max-width: 170px;">
              <b-form-input v-model="toDate" @input="loadRentalGins()" type="date" />
            </b-input-group>

            <div class="ms-md-2 mt-2 mt-md-0">
              <span class="custom-breadcrumb d-block text-center text-md-start">
                <b>Showing {{ rangeStart }} - {{ rangeEnd }} of {{ totalRows }} items.</b>
              </span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="createGin()" class="btn btn-outline-primary btn-sm mb-1 mt-1 bdr-rad">
              Create Rental GIN
            </button>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                style="font-size: small;"
                class="table-hover"
                :items="allDatas"
                :fields="fields"
                :current-page="1"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
              >
                <template #cell(number)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>

                <template #cell(period)="row">
                  {{ formatPeriod(row.item) }}
                </template>

                <template #cell(total_rate)="row">
                  {{ formatAmount(row.item.total_rate) }}
                </template>

                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewGin(row.item.id)">View</a>
                      <a class="dropdown-item mouse-cursor" v-show="row.item.statusvalue == 1" @click="confirmGin(row.item.id)">Confirm</a>
                      <a class="dropdown-item mouse-cursor" v-show="row.item.statusvalue == 3" @click="createInvoice(row.item.id)">Create Invoice</a>
                    </div>
                  </div>
                </template>
              </b-table>

              <b-col style="padding-left: 0;" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" @input="loadRentalGins()" />
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  name: "RentalGinIndex",
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      accessToken: authService.isLoggedIn(),
      allDatas: [],
      filter: null,
      fromDate: null,
      toDate: null,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      fields: [
        { key: "number", label: "#", sortable: true, sortDirection: "desc" },
        { key: "issue_no", label: "GIN No.", sortable: true },
        { key: "issue_date", label: "Issue Date", sortable: true },
        { key: "customer_name", label: "Customer", sortable: true },
        { key: "customer_contact", label: "Contact No.", sortable: true },
        { key: "sales_person_name", label: "Sales Person", sortable: true },
        { key: "period", label: "Rental Period", sortable: false },
        { key: "unit_count", label: "Units", sortable: true, class: "text_right" },
        { key: "total_rate", label: "Per Day Rate", sortable: true, class: "text_right" },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions", class: "width-custom7" },
      ],
    };
  },
  computed: {
    rangeStart() {
      if (!this.totalRows) {
        return 0;
      }

      return (this.currentPage - 1) * this.perPage + 1;
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.perPage, this.totalRows);
    },
  },
  mounted() {
    this.loadRentalGins();
  },
  methods: {
    headers() {
      return {
        Authorization: "Bearer " + this.accessToken,
        "Content-type": "application/json",
      };
    },
    async loadRentalGins() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("/rentalgin/index", {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            filter: this.filter || "",
            fromDate: this.fromDate || "",
            toDate: this.toDate || "",
          },
          headers: this.headers(),
        });

        this.allDatas = data.all_data || [];
        this.totalRows = data.total_count || this.allDatas.length || 0;
      } catch (error) {
        console.log(error.response || error);
        this.allDatas = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },
    formatPeriod(item) {
      if (!item.from_date && !item.to_date) {
        return "-";
      }

      return `${item.from_date || "-"} - ${item.to_date || "-"}`;
    },
    formatAmount(value) {
      const amount = Number(value || 0);
      return amount.toFixed(2);
    },
    createGin() {
      this.$router.push("/rental/gin");
    },
    viewGin(id) {
      this.$router.push("/rental/gin?id=" + id);
    },
    createInvoice(id) {
      this.$router.push("/rental/createrentalinvoice?id=" + id);
    },
    async confirmGin(id) {
      if (!confirm("Are you sure you want to confirm this Rental GIN?")) {
        return;
      }

      try {
        const { data } = await axios.post("/rentalgin/confirm?id=" + id, {}, {
          headers: this.headers(),
        });

        if (data.status === 200) {
          this.loadRentalGins();
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
};
</script>
